import styled from "styled-components";

export const HeadBox = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0px 5px 0px 5px;
  padding: 0px 10px 0 10px;
`;
export const Head = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  overflow: hidden;
  font-size: 12px;
  justify-content: center;
  align-items: center;
  align-items: center;
  padding: 20px 0px 5px 0px;
  margin: auto;
  position: relative;
  margin: auto;
  position: relative;
  > span {
    background-color: red;
    color: white;
    border-radius: 50%;
    font-size: 12px;
    width: 50px;
    height: 50px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }
  img {
    border-radius: 50%;
    width: 50px !important;
    height: 50px !important;
  }
  &::after {
    content: "";
    width: 1px;
    height: 15px;
    background:#3FC4FD;
    position: absolute;
    bottom: 0;
  }
  &::before {
    content: "";
    width: 1px;
    height: 20px;
    background:#3FC4FD;
    position: absolute;
    top: 0;
  }
  &.last {
    &::after {
      display: none;
    }
  }
  &.first {
    &::before {
      display: none;
    }
  }
  p {
    font-weight: bold;
  }
  &.last p {
    margin-bottom: 0;
  }
  p:nth-child(3) {
    margin-top: 5px;
    font-size: 10px;
    font-weight: normal;
  }
`;
export const HeadContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 0px 0px 0px;
  // justify-content: center;
  position: relative;
  &.row{
    flex-direction: row;
    border-top: 0px solid lightgray;
    border-left: 0px solid lightgray;
    border-right: 0px solid lightgray;
    border-radius: 30px 30px 0 0;
    width: fit-content;
    justify-content: center;
    // align-items: center;
    margin: auto;
    max-width: 100%;
    width: 100%;
    flex-flow: nowrap !important;
    
  
  }
  &.employee{
    flex-flow: wrap !important;
  
  }
  &.row-head {
    flex-direction: row;
    border-top: 0px solid lightgray;
    border-left: 0px solid lightgray;
    border-right: 0px solid lightgray;
    border-radius: 30px 30px 0 0;
    width: fit-content;
    justify-content: center;
    align-items: center;
    margin: auto;
    max-width: 100%;
    width: 100%;
    flex-flow: wrap;
  }
  &.row > div::before {
    content: "";
    left: 0;
    right: 0;
    height: 1px;
    background:#3FC4FD;
    position: absolute;
    top: 0;
  }
  &.row > div:first-child::before {
    left: 50%;
  }
  &.row > div:last-child::before {
    right: 50%;
  }
  /* &.row > div:first-child::before, .row > div:last-child::before {
    left: 50%;
    right: 50%;
  } */
  &.row-head > div::after {
    content: "";
    left: 0;
    right: 0;
    height: 1px;
    background: #3FC4FD;
    position: absolute;
    bottom: -1px;
  }
  &.row-head > div:first-child::after {
    left: 50%;
  }
  &.row-head > div:last-child::after {
    right: 50%;
  }
  &.main {
    margin: 20px auto auto auto;
    flex-direction: row;
    justify-content: center;
    align-items: baseline;
  }
  &.row::before,
  &.main::before,
  &.row::after,
  &.main::after {
    display: none;
  }
`;

export const Collapse = styled.span`
  // margin-left: 10px;
  padding: 5px;
  cursor: pointer;
  svg {
    transition: 0.2s ease-out;
  }
  &.true svg {
    transform: rotate(0deg);
  }
`;

export const OrgInput = styled.div`
    width: 400px;
    position: absolute;
    top: 40px;
    right: 20px;
    z-index: 1;
`;

// <Container className="noshadow organChart">
    //   <HeadContainer className="main">
    //     <HeadContainer>
    //       <HeadContainer className="row-head">
    //         {dashboard.data?.admins?.map((admin, index) => {
    //           const amdinName = `${admin.firstName} ${admin.lastName}`;
    //           return (
    //             <HeadContainer key={index}>
    //               <HeadBox>
    //                 <Head className="first">
    //                   {generateThumbnail(amdinName, null, admin.photo)}
    //                   <p>{amdinName}</p>
    //                 </Head>
    //               </HeadBox>
    //             </HeadContainer>
    //           );
    //         })}
    //       </HeadContainer>
    //       <HeadContainer className="row">
    //         {dashboard.data?.hierarchy?.map((item, index) => {
    //           const locationName =
    //             typeof item.location === "object"
    //               ? item.location.title
    //               : item.location;
    //           return (
    //             <HeadContainer key={index}>
    //               <HeadBox className="box">
    //                 <Head>
    //                   {generateThumbnail(locationName)}
    //                   <p>{locationName}</p>
    //                 </Head>
    //                 <HeadContainer className="row">
    //                   {item.departments?.map((departmentItem, index1) => {
    //                     const departmentName =
    //                       typeof departmentItem.department === "object"
    //                         ? departmentItem.department.title
    //                         : departmentItem.department;
    //                     return (
    //                       <HeadContainer key={index1}>
    //                         <HeadBox>
    //                           <Head>
    //                             {generateThumbnail(departmentName)}
    //                             <p>{departmentName}</p>
    //                           </Head>
    //                           <HeadContainer className="row">
    //                             {departmentItem.places?.map(
    //                               (placeItem, index2) => {
    //                                 const collapse =
    //                                   openedPlace[
    //                                     `place-${index1}-${index2}`
    //                                   ] ?? false;
    //                                 const placeName =
    //                                   typeof placeItem.place === "object"
    //                                     ? placeItem.place.title
    //                                     : placeItem.place;
    //                                 return (
    //                                   <HeadContainer key={index2}>
    //                                     <HeadBox>
    //                                       <Head>
    //                                         {generateThumbnail(placeName)}
    //                                         <div
    //                                           style={{
    //                                             display: "flex",
    //                                             flexDirection:'column',
    //                                             gap: "0px",
    //                                             alignItems:'center'
    //                                           }}
    //                                         >
    //                                           <p>{placeName}</p>
    //                                           <Collapse
    //                                             className={collapse}
    //                                             onClick={() => {
    //                                               // const loadedDataTemp = { ...loadedData };
    //                                               setOpenedPlace({
    //                                                 ...openedPlace,
    //                                                 [`place-${index1}-${index2}`]:
    //                                                   !collapse,
    //                                               });
    //                                             }}
    //                                           >
    //                                             {collapse ? (
    //                                               <GetIcon
    //                                               fontSize="20px"
    //                                                 icon={"zoom-out"}
    //                                               ></GetIcon>
    //                                             ) : (
    //                                               <GetIcon
    //                                               fontSize="20px"
    //                                                 icon={"zoom-in"}
    //                                               ></GetIcon>
    //                                             )}
    //                                           </Collapse>
    //                                         </div>
    //                                       </Head>
    //                                       {collapse && <HeadContainer className={`row ${placeItem.employees?.length>10?"employee":""}`}>
    //                                         {placeItem.employees?.map(
    //                                           (employee, index3) => {
    //                                             const employeeName = `${employee.firstName} ${employee.lastName}`;
    //                                             return (
    //                                               <HeadContainer key={index3}>
    //                                                 <HeadBox>
    //                                                   <Head className="last">
    //                                                     {console.log(employee)}
    //                                                     {generateThumbnail(
    //                                                       employeeName,
    //                                                       null,
    //                                                       employee.photo
    //                                                     )}
    //                                                     <p>{employeeName}</p>
    //                                                     <p>
    //                                                       {employee.designation
    //                                                         ? employee
    //                                                             .designation
    //                                                             .title
    //                                                         : ""}
    //                                                     </p>
    //                                                   </Head>
    //                                                 </HeadBox>
    //                                               </HeadContainer>
    //                                             );
    //                                           }
    //                                         )}
    //                                       </HeadContainer>}
    //                                     </HeadBox>
    //                                   </HeadContainer>
    //                                 );
    //                               }
    //                             )}
    //                           </HeadContainer>
    //                         </HeadBox>
    //                       </HeadContainer>
    //                     );
    //                   })}
    //                 </HeadContainer>
    //               </HeadBox>
    //             </HeadContainer>
    //           );
    //         })}
    //       </HeadContainer>
    //     </HeadContainer>
    //   </HeadContainer>
    // </Container>